import { render } from "./multalistainfraccion.vue?vue&type=template&id=1c92f53e&scoped=true"
import script from "./multalistainfraccion.vue?vue&type=script&lang=js"
export * from "./multalistainfraccion.vue?vue&type=script&lang=js"

import "./multalistainfraccion.vue?vue&type=style&index=0&id=1c92f53e&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c92f53e"]])

export default __exports__